
import Vue from 'vue';
import Component from 'vue-class-component';
import { EPermissionActions } from '@/model/EPermissionActions';

interface NavTab {
  route: string;
  icon: string;
  labelKey: string;
  label?: string;
  // Without actions the tab is visible to anyone who can enter the helpdesk (the layout's guard).
  actions?: EPermissionActions[];
}

// Top nav of the helpdesk, same format as UserNav / OrderSectionTabs. It replaces the helpdesk
// items of the LeftNav with the same order, icons and visibility rules as they had there.
@Component({ name: 'HelpdeskNav' })
export default class HelpdeskNav extends Vue {
  private allTabs: NavTab[] = [
    { route: 'helpdeskDashboard',   icon: 'mdi-view-dashboard-outline', labelKey: 'menu.helpdesk.dashboard' },
    { route: 'helpdeskInbox',       icon: 'mdi-email-multiple-outline', labelKey: 'menu.helpdesk.inbox' },
    { route: 'helpdeskWhatsapp',    icon: 'mdi-whatsapp',               labelKey: 'menu.helpdesk.whatsapp',
      actions: [EPermissionActions.ACTION_HELPDESK_WHATSAPP, EPermissionActions.ACTION_HELPDESK_ADMIN] },
    { route: 'helpdeskSent',        icon: 'mdi-send-outline',           labelKey: 'menu.helpdesk.sentEmails' },
    { route: 'helpdeskAccounts',    icon: 'mdi-gmail',                  labelKey: 'menu.helpdesk.accounts',
      actions: [EPermissionActions.ACTION_HELPDESK_ADMIN] },
    { route: 'helpdeskTickets',     icon: 'mdi-ticket-outline',         labelKey: 'menu.helpdesk.tickets' },
    { route: 'helpdeskSpam',        icon: 'mdi-shield-alert-outline',   labelKey: 'menu.helpdesk.spam' },
    { route: 'helpdeskTicketTypes', icon: 'mdi-tag-outline',            labelKey: 'menu.helpdesk.ticketTypes' },
    { route: 'helpdeskTemplates',   icon: 'mdi-text-box-outline',       labelKey: 'menu.helpdesk.templates' },
    { route: 'helpdeskSignatures',  icon: 'mdi-draw-pen',               labelKey: 'menu.helpdesk.signatures' },
  ];

  get visibleTabs(): NavTab[] {
    return this.allTabs
      .filter(tab => !tab.actions || tab.actions.some(action => this.$canAction(action)))
      .map(tab => ({
        ...tab,
        label: this.$t(tab.labelKey) as string,
      }));
  }

  get activeTabIndex(): number {
    const currentRoute = this.$route.name;
    return this.visibleTabs.findIndex(tab => tab.route === currentRoute);
  }

  isActive(routeName: string): boolean {
    return this.$route.name === routeName;
  }
}
